<template>
   <div>
       <el-input
               size="small"
               v-model="filterName"
               placeholder="输入关键字进行过滤"
               style="margin-bottom: 10px;"
       ></el-input>
       <input  type="text" :value="value" style='display:none;'>

       <el-tree :highlight-current="true" :expand-on-click-node="false" ref="tree" :data="data" :props="defaultProps" @node-click="handleNodeClick" :filter-node-method="filterNode"></el-tree>
   </div>
</template>

<script>
    export default {
        name: "ModuleTree",
        props:{
            value: {
                type: String,
                default:''
            },
        },
        watch: {
            filterName(val) {
                this.$refs.tree.filter(val);
            }
        },
        data() {
            return {
                data: [],
                filterName:'',
                defaultProps: {
                    children: 'children',
                    label: 'name'
                }
            };
        },
        methods: {
            filterNode(value, data){
                if (!value) return true;
                return data.name.indexOf(value) !== -1;
            },
            handleNodeClick(data) {
                this.$emit('input',data.code);
            }
        },
        created() {
            let vm = this;
            vm.$http.post(vm.$api.module.tree).then((resp)=>{

                if(resp.data.status === 200){
                   vm.data =  resp.data.data.moduleTree.children;
                }

            })
        }
    }
</script>

<style scoped>

</style>